@if (currentSelectedStory()) {
    <st-story-full-screen
        standaloneStory
        [autoUpdate]="currentSelectedStory()?.isNewRecord"
        [data]="currentSelectedStory()"
        [parentTopic]="parentTopic()"
        [sidecarMenu]="sidecarMenu()"
        [disabled]="currentSelectedStory()?.topicMetadata?.Path?.isWasteBinPath" />
    <div class="st-stories-list-sidecar-pager">
        <button
            mat-icon-button
            class="st-stories-list-sidecar-pager-button-first"
            (click)="navigate($event, NavigationDirection.FIRST)">
            <mat-icon>first_page</mat-icon>
        </button>
        <button
            mat-icon-button
            class="st-stories-list-sidecar-pager-button-previous"
            (click)="navigate($event, NavigationDirection.PREVIOUS)">
            <mat-icon>navigate_before</mat-icon>
        </button>
        <span class="st-stories-list-sidecar-pager-text">Story {{ currentIdx() }} of {{ totalCount() }}</span>
        <button
            mat-icon-button
            class="st-stories-list-sidecar-pager-button-next"
            (click)="navigate($event, NavigationDirection.NEXT)">
            <mat-icon>navigate_next</mat-icon>
        </button>
        <button
            mat-icon-button
            class="st-stories-list-sidecar-pager-button-last"
            (click)="navigate($event, NavigationDirection.LAST)">
            <mat-icon>last_page</mat-icon>
        </button>
    </div>
} @else {
    <div class="st-stories-list-sidecar-label">
        <span>{{ storiesLabel() }}</span>
        <st-item-layout-toggle
            [showLabel]="true"
            [isCondensed]="isStoriesCondensedLayout()"
            (layoutChange)="setStoriesCondensedLayout($event)" />
    </div>
    <div class="st-stories-list-sidecar__grid">
        <mat-button-toggle-group
            class="st-stories-list-sidecar-buttons-group"
            [value]="selectedListSearchType()"
            (change)="toggleSearchTab($event)">
            <mat-button-toggle
                class="st-stories-list-sidecar-buttons-group__search"
                [value]="SearchType.SEARCH">
                {{ languageSettings.PSTWebCastSearchTabLabel }}
            </mat-button-toggle>
            <mat-button-toggle
                class="st-stories-list-sidecar-buttons-group__views"
                [value]="SearchType.SAVED">
                {{ languageSettings.PSTWebSavedViewsTabLabel }}
            </mat-button-toggle>
        </mat-button-toggle-group>

        <div class="st-stories-list-sidecar__grid__right">
            @if (savedViewDropdownVisible()) {
                <mat-form-field
                    class="st-stories-list-sidecar__views-dropdown"
                    subscriptSizing="dynamic">
                    <mat-label>{{ languageSettings.PSTWebCastObjectsDropDownLabel }}</mat-label>
                    <mat-select
                        [value]="currentViewState()?.Guid"
                        [placeholder]="languageSettings.PSTWebSavedViewsLabel"
                        (selectionChange)="onViewStateGuidChanged($event)">
                        @for (item of selectSavedViewStates(); track item.Guid) {
                            <mat-option [value]="item.Guid">
                                {{ item.Title }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            } @else {
                <div class="st-stories-list-sidecar__search-bar">
                    <st-simple-search-box-autocomplete
                        st-click-stop-propagation
                        class="st-cast-objects-list__search-bar__search"
                        (searchExecute)="onSearchHandler($event)" />
                </div>
            }
        </div>
    </div>
    @if (selectStories()?.length === 0) {
        <div class="st-stories-list-sidecar-text">
            {{ 'Sorry, there are no results matching your criteria' }}
        </div>
    } @else {
        <div class="st-stories-list-sidecar-list-container">
            @if (isStoriesCondensedLayout()) {
                <st-condensed-list-header-labels
                    class="st-stories-list-sidecar-condensed-header"
                    [cardViewType]="cardViewType()"
                    [showApprove]="showApproveColumn()" />
            }
            <cdk-virtual-scroll-viewport
                maxBufferPx="0"
                minBufferPx="0"
                class="st-stories-list-sidecar-viewport"
                [itemSize]="itemSize()">
                <div
                    *cdkVirtualFor="let record of selectStories(); last as isLast; trackBy: trackByGuid; templateCacheSize: 0"
                    class="st-stories-list-sidecar-viewport-story-item-type">
                    @if (isStoriesCondensedLayout()) {
                        <st-story-item-condensed
                            [data]="record"
                            [cardViewType]="cardViewType()"
                            [isReadOnly]="record?.topicMetadata?.Path?.isWasteBinPath"
                            [sidecarType]="sidecarMenu()"
                            (storyItemClicked)="onFullscreenHandler(record)" />
                    } @else {
                        <st-story-item
                            [data]="record"
                            [inSidecarOpenedMode]="isSideCarMenuSelected()"
                            [cardViewType]="cardViewType()"
                            [attr.small]="cardViewType() === CardViewType.SMALL"
                            [topicRecord]="record.topicMetadata"
                            [disabled]="record?.topicMetadata?.Path?.isWasteBinPath"
                            [sidecarType]="sidecarMenu()"
                            (itemClicked)="onFullscreenHandler(record)" />
                    }
                </div>
            </cdk-virtual-scroll-viewport>
        </div>
    }
}
